import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
  carrier: '',
  identifier: '',
  trackingStatus: { view: '', request: '' },
  initialDate: '',
  endDate: '',
  filteredMode: false,
};

const shippingsSlice = createSlice({
  name: 'shippingsUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setCarrier: (state, action) => {
      state.carrier = action.payload;
    },
    setIdentifier: (state, action) => {
      state.identifier = action.payload;
    },
    setInitialDate: (state, action) => {
      state.initialDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setTrackingStatus: (state, action) => {
      state.trackingStatus = action.payload;
    },
    setFilteredMode: (state, action) => {
      state.filteredMode = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, setCarrier, setIdentifier, setInitialDate, setEndDate, setTrackingStatus, setFilteredMode, resetFilters } =
  shippingsSlice.actions;
const userShippingsReducer = shippingsSlice.reducer;
export default userShippingsReducer;
